export enum CLIENTS {
  SEMA_BET = 'semaBet',
  BET_ONLY = 'betonly',
  BETPRAZER = 'betprazer',
  OTBET = 'otbet',
  NONE = 'none',
}
